<bp-page-header
    [title]="formMode === QuoteFormCrudMode.Create ? 'New WA rebate application' : 'Edit WA rebate application'"
    [subTitle]="quoteNumber ? ('Quote Record number: ' + quoteNumber + '<br>Current status: ' + quoteStatus) : ''">
</bp-page-header>
<section class="dashboard-container">
    <p *ngIf="formMode !== QuoteFormCrudMode.Create && _getUneditableReason()">
        This Quote Record cannot be edited {{ _getUneditableReason() }}
    </p>
    <form [formGroup]="form" (ngSubmit)="_onSubmit()" fxLayout="column" fxLayoutGap="20px" #ngForm="ngForm">
        <section *ngIf="_shouldDisplayTopActions()">
            <ng-container *ngTemplateOutlet="tmplActions"></ng-container>
        </section>

        <ng-container *ngIf="formMode !== QuoteFormCrudMode.View;else tmplViewMode">
            <section>
                <h3>Customer details</h3>
                <mat-card>
                    <mat-card-content fxLayout="column" fxLayoutGap="20px" fxLayoutGap.lt-md="10px">
                        <bp-alert *ngIf="formMode === QuoteFormCrudMode.Create" [severity]="'warning'" [dismissible]="false">
                            Please double-check that the details entered match the customer's driver's license.<br>
                            Email and mobile must be accurate - they cannot be changed later.
                        </bp-alert>
                        <div fxFlex>
                            <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px"
                                fxLayoutGap.lt-md="0px">
                                <mat-form-field fxFlex>
                                    <input matInput type="text" placeholder="First name" formControlName="firstName"
                                        data-cy="input.firstName" />
                                    <mat-error *ngIf="form.controls['firstName'].hasError('required')">
                                        Please enter a first name
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field fxFlex>
                                    <input matInput type="text" placeholder="Middle name" formControlName="middleName"
                                        data-cy="input.middleName" />
                                    <mat-error *ngIf="form.controls['middleName'].hasError('required')">
                                        Please enter a middle name
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field fxFlex>
                                    <input matInput type="text" placeholder="Last name" formControlName="lastName"
                                        data-cy="input.lastName" />
                                    <mat-error *ngIf="form.controls['lastName'].hasError('required')">
                                        Please enter a last name
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div fxFlex>
                            <div fxFlex fxFlex.gt-sm="80%" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="20px"
                                fxLayoutGap.lt-md="0px">
                                <mat-form-field fxFlex>
                                    <input matInput type="email" placeholder="Email" formControlName="email" data-cy="input.email" />
                                    <mat-error *ngIf="form.controls['email'].hasError('required')">
                                        Please enter an email address
                                    </mat-error>
                                    <mat-error
                                        *ngIf="!form.controls['email'].hasError('required') && form.controls['email'].hasError('email')">
                                        Please enter a valid email address
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field fxFlex>
                                    <input matInput type="tel" placeholder="Mobile" formControlName="mobile" data-cy="input.mobile" />
                                    <mat-error *ngIf="form.controls['mobile'].hasError('required')">
                                        Please enter a mobile number
                                    </mat-error>
                                    <mat-error *ngIf="form.controls['mobile'].hasError('pattern')">
                                        Please enter a valid mobile number
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div *ngIf="formMode === QuoteFormCrudMode.Create" fxFlex>
                            <div fxFlex fxFlex.gt-sm="80%" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                                <div fxFlex fxLayout="column">
                                    <mat-checkbox formControlName="confirmCorrectCustomerDetails">
                                        I confirm these details match the customer's driver's license and the email and mobile number are accurate.</mat-checkbox>
                                    <mat-error *ngIf="(ngForm.submitted || form.controls['confirmCorrectCustomerDetails'].touched) &&
                                            form.controls['confirmCorrectCustomerDetails'].hasError('required')"
                                        class="subscript">
                                        Please confirm
                                    </mat-error>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </section>

            <section>
                <h3>Installation address</h3>
                <mat-card>
                    <mat-card-content fxLayout="column" fxLayoutGap="20px" fxLayoutGap.lt-md="10px">
                        <div fxFlex>
                            <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px"
                                fxLayoutGap.lt-md="0px">
                                <bp-address fxFlex formGroupName="installationAddress" [states]="[{ key: 'WA', value: 'Western Australia'}]"
                                    [placeholderConfigs]="{'fullAddress': 'Installation address'}" [errorMessageConfigs]="{
                                            'fullAddress': {
                                                'pattern': 'This address is not eligible for a WA battery rebate'
                                            },
                                            'state': {
                                                'unacceptedValue': 'Only \'Western Australia\' is allowed'
                                            }}">
                                </bp-address>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </section>

            <section>
                <h3>Energy retailer details</h3>
                <mat-card>
                    <mat-card-content fxLayout="column" fxLayoutGap="20px" fxLayoutGap.lt-md="10px">
                        <div fxFlex>
                            <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px"
                                fxLayoutGap.lt-md="0px">
                                <div fxFlex>Which network area is your customer in?</div>
                                <div fxFlex>
                                    <mat-form-field fxFlex>
                                        <mat-label>Network Area</mat-label>

                                        <mat-select formControlName="networkArea" placeholder="Select network area">
                                            <mat-option *ngFor="let opt of _networkAreas" [value]="opt.value">{{opt.label}}</mat-option>
                                        </mat-select>

                                        <button type="button" mat-icon-button matSuffix *ngIf="form.get('networkArea').value"
                                            (click)="form.get('networkArea').reset()">
                                            <mat-icon>close</mat-icon>
                                        </button>

                                        <mat-error *ngIf="form.get('networkArea').hasError('required')">
                                            Please select a network area
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div fxFlex formArrayName="activities">
                            <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px"
                                fxLayoutGap.lt-md="0px" formGroupName="0">
                                <div fxFlex>VPP</div>
                                <div fxFlex>
                                    <mat-form-field fxFlex>
                                        <mat-select formControlName="vpp" placeholder="Select VPP">
                                            <mat-option *ngFor="let opt of _filteredVpps" [value]="opt.value">{{opt.label}}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="form.get('activities.0.vpp').hasError('required')">
                                            Please select a VPP
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <ng-container  *ngIf="form.get('activities.0.vpp')?.value === 'Synergy'">
                            <div fxFlex>
                                <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                                    <div fxFlex>
                                        Please confirm that your new residential battery customers are only eligible on active
                                        residential tariffs - Home Plan (A1), Midday Saver, EV Add On or Home Business Plan (K1)
                                    </div>
                                    <div fxFlex fxLayout="column">
                                        <mat-slide-toggle formControlName="isEligibleOnActiveResidentialTariffs"
                                            #isEligibleOnActiveResidentialTariffs></mat-slide-toggle>
                                        <mat-hint *ngIf="!isEligibleOnActiveResidentialTariffs.checked" class="field-warning small-warning">
                                            If the customer is not on an active residential tariff, the customer will be required to switch to an eligible tariff. If the customer does not act within 14 days of their battery installation, Synergy will migrate them to the Home Plan (A1) in accordance with the terms of the Synergy electricity standard agreement
                                        </mat-hint>
                                    </div>
                                </div>
                            </div>

                            <div fxFlex>
                                <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                                    <div fxFlex>
                                        Inverters on Synergy's Supported Solutions List can be supported by in-built or gateway solutions. Some inverters need a specific gateway to comply. You confirm that you've checked the Supported Solutions List and will install the correct gateway if required. You also confirm you will comply with the whole-of-site compliance requirements in Synergys DER functionality requirements for battery installs at sites with existing DER.
                                    </div>
                                    <div fxFlex fxLayout="column">
                                        <mat-slide-toggle formControlName="isSynergyComplianceConfirmed"
                                            #isSynergyComplianceConfirmed></mat-slide-toggle>
                                    </div>
                                </div>
                            </div>

                            <div fxFlex>
                                <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                                    <mat-hint fxFlex>
                                        If I am not the Synergy customer completing this application, I confirm I have the Synergy customer's
                                        authorised and verifiable consent to lodge this application on the customer's behalf. I confirm I have
                                        disclosed all relevant matters to the customer for the purposes of obtaining their verifiable consent
                                        to act on their behalf for the purposes of lodging this application
                                    </mat-hint>
                                    <div fxFlex fxLayout="column">
                                        <mat-slide-toggle formControlName="isSynergyCustomerConsentConfirmed"
                                            #isSynergyCustomerConsentConfirmed></mat-slide-toggle>
                                        <mat-error *ngIf="(ngForm.submitted || form.controls['isSynergyCustomerConsentConfirmed'].touched) &&
                                                form.controls['isSynergyCustomerConsentConfirmed'].hasError('required')"
                                            class="subscript">
                                            Please confirm
                                        </mat-error>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <div fxFlex>
                            <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px"
                                fxLayoutGap.lt-md="0px">
                                <div fxFlex fxLayout="column">
                                    <p>National Meter Identifier (NMI)</p>
                                    <mat-hint class="field-warning small-warning">
                                        The NMI is found on an electricity bill issued by a retailer. You will need to request this
                                        from the customer
                                    </mat-hint>
                                </div>
                                <div fxFlex>
                                    <mat-form-field fxFlex fxFlex.gt-sm="50%">
                                        <input matInput type="text" formControlName="nmi" placeholder="National Meter Identifier (NMI)"
                                            data-cy="input.nmi" />
                                        <mat-error *ngIf="form.controls['nmi'].hasError('required')">
                                            Please enter the NMI
                                        </mat-error>
                                        <mat-error *ngIf="form.controls['nmi'].hasError('pattern')">
                                            Please ensure the NMI provided is 11 digits long
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </section>

            <section>
                <h3>System details</h3>
                <mat-card>
                    <mat-card-content fxLayout="column" fxLayoutGap="20px" fxLayoutGap.lt-md="10px">
                        <div fxFlex>
                            <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px"
                                fxLayoutGap.lt-md="0px">
                                <div fxFlex>Battery system</div>
                                <div fxFlex fxLayout="column">
                                    <div fxFlex fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign.gt-sm=" center" fxLayoutGap.gt-sm="15px">
                                        <bp-cec-package-select formControlName="batteryPackage" category="battery" filterStrategy="onDemand"
                                            placeholder="Start typing to search battery"
                                            (selectedPackageChange)="_batteryPackageSelected($event)">
                                            <mat-error>
                                                <ng-container *ngIf="form.controls['batteryPackage'].hasError('required')">
                                                    Please enter the battery.
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="form.controls['batteryPackage'].hasError('invalid') || form.controls['batteryPackage'].hasError('notfound')">
                                                    Invalid battery.
                                                </ng-container>
                                            </mat-error>
                                        </bp-cec-package-select>
                                        <div *ngIf="multipleBatteryEnabled" fxFlex>
                                            <mat-checkbox formControlName="hasMultipleBatteries">Multiple batteries/modules</mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                         <div *ngIf="form.controls['hasMultipleBatteries']?.value" fxFlex>
                            <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px"
                                fxLayoutGap.lt-md="0px">
                                <div fxFlex>Number of batteries</div>
                                <div fxFlex>
                                    <mat-form-field fxFlex fxFlex.gt-sm="50%">
                                        <input matInput type="number" formControlName="numberOfBatteries" placeholder="Number of batteries"
                                            data-cy="input.numberOfBatteries" />
                                        <mat-error *ngIf="form.get('numberOfBatteries').hasError('required')">
                                            Please enter the amount
                                        </mat-error>
                                        <mat-error *ngIf="form.get('numberOfBatteries').hasError('pattern')">
                                            Please enter a valid amount
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div fxFlex>
                            <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px"
                                fxLayoutGap.lt-md="0px">
                                <div fxFlex>Inverter system</div>
                                <div fxFlex fxLayout="column">
                                    <div fxFlex fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign.gt-sm=" center" fxLayoutGap.gt-sm="15px">
                                        <bp-cec-package-select fxFlex formControlName="inverterPackage" category="inverter" filterStrategy="onDemand"
                                            placeholder="Start typing to search inverter" [filterParams]="{ energyRetailer: form.get('activities.0.vpp').value }"
                                            (selectedPackageChange)="_inverterPackageSelected($event)">
                                            <mat-error>
                                                <ng-container *ngIf="form.controls['inverterPackage'].hasError('required')">
                                                    Please enter the inverter.
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="form.controls['inverterPackage'].hasError('invalid') || form.controls['inverterPackage'].hasError('notfound')">
                                                    Invalid inverter.
                                                </ng-container>
                                            </mat-error>
                                        </bp-cec-package-select>
                                        <mat-checkbox formControlName="hasExistingInverter">Existing inverter</mat-checkbox>
                                    </div>
                                    <mat-hint class="field-warning small-warning">
                                        (If an existing inverter has already been installed please select the inverter model from the supported solution list)
                                    </mat-hint>
                                </div>
                            </div>
                        </div>

                        <div fxFlex>
                            <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px"
                                fxLayoutGap.lt-md="0px">
                                <div *ngIf="multipleBatteryEnabled" fxFlex>Total battery cost ($) of all batteries installed</div>
                                <div *ngIf="!multipleBatteryEnabled" fxFlex>Total battery cost ($)</div>
                                <div fxFlex>
                                    <mat-form-field fxFlex fxFlex.gt-sm="50%">
                                        <input matInput bpCurrencyFormat formControlName="packagePrice" placeholder="Total battery cost ($)"
                                            data-cy="input.packagePrice" />
                                        <mat-error *ngIf="form.get('packagePrice').hasError('required')">
                                            Please enter the amount
                                        </mat-error>
                                        <mat-error *ngIf="form.get('packagePrice').hasError('pattern')">
                                            Please enter a valid amount
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div fxFlex>
                            <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px"
                                fxLayoutGap.lt-md="0px">
                                <div fxFlex>Total cost of installation</div>
                                <div fxFlex>
                                    <mat-form-field fxFlex fxFlex.gt-sm="50%">
                                        <input matInput bpCurrencyFormat formControlName="installationPrice"
                                            placeholder="Total cost of installation ($)" data-cy="input.installationPrice" />
                                        <mat-error *ngIf="form.get('installationPrice').hasError('required')">
                                            Please enter the amount
                                        </mat-error>
                                        <mat-error *ngIf="form.get('installationPrice').hasError('pattern')">
                                            Please enter a valid amount
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div fxFlex formArrayName="activities">
                            <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px"
                                fxLayoutGap.lt-md="0px" formGroupName="0">
                                <div fxFlex>WA Battery Rebate amount</div>
                                <div fxFlex>
                                    <mat-form-field fxFlex fxFlex.gt-sm="50%">
                                        <input matInput bpCurrencyFormat formControlName="rebateAmount"
                                            placeholder="WA Battery Rebate amount ($)" readonly data-cy="input.activities.0.rebateAmount" />
                                        <mat-error *ngIf="form.get('activities.0.rebateAmount').hasError('min')">
                                            Systems under 5kWh are ineligible for a rebate. Please adjust your selection before submitting.
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div fxFlex formArrayName="activities">
                            <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px"
                                fxLayoutGap.lt-md="0px" formGroupName="0">
                                <div fxFlex fxLayout="column">
                                    <p>Total amount owed by the customer (after applied rebate)</p>
                                    <mat-hint class="field-warning small-warning">
                                        Ensure the total amount owing includes all applicable rebates being applied
                                    </mat-hint>
                                </div>
                                <div fxFlex>
                                    <span>{{form.get('activities.0.subtotal').value | currency:'AUD':'symbol-narrow'}}</span>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </section>

            <section>
                <h3>Finance</h3>
                <mat-card>
                    <mat-card-content fxLayout="column" fxLayoutGap="20px" fxLayoutGap.lt-md="10px">
                        <div fxFlex>
                            <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px"
                                fxLayoutGap.lt-md="0px">
                                <div fxFlex>Would you like to apply for interest free finance?</div>
                                <div fxFlex>
                                    <mat-slide-toggle formControlName="optInFinance" #tglOptInFinance></mat-slide-toggle>
                                </div>
                            </div>
                        </div>
                        <ng-container *ngIf="tglOptInFinance.checked">
                            <div fxFlex>
                                <bp-alert [severity]="'info'" [dismissible]="false">
                                    The WA Battery Scheme has a maximum loan limit of {{WABSLoanLimit | currency:'AUD':'symbol-narrow':'1.0-0'}}.
                                    If the total amount owed exceeds this limit, the customer will need to pay a deposit.
                                </bp-alert>
                            </div>
                            <div fxFlex>
                                <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign.gt-sm="start center"
                                    fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                                    <div fxFlex>Total amount owed by customer (after rebate)</div>
                                    <div fxFlex fxFlex.gt-sm="50%">
                                        <span data-cy="display.balance">{{form.get('balance').value | currency:'AUD':'symbol-narrow'}}</span>
                                    </div>
                                </div>
                            </div>
                            <div fxFlex>
                                <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign.gt-sm="start center"
                                    fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                                    <div fxFlex>Deposit</div>
                                    <div fxFlex fxFlex.gt-sm="50%" fxLayout="column">
                                        <div>
                                            <mat-form-field style="max-width: 200px;">
                                                <input matInput bpCurrencyFormat formControlName="customerDeposit" placeholder="Deposit ($)"
                                                    name="customerDeposit" data-cy="input.customerDeposit" />
                                                <mat-error *ngIf="form.controls['customerDeposit'].hasError('min')">
                                                    Please enter the amount
                                                </mat-error>
                                                <mat-error *ngIf="form.controls['customerDeposit'].hasError('pattern')">
                                                    Please enter a valid amount
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <mat-hint 
                                            [class.field-warning]="true"
                                            [class.small-warning]="true"
                                            [class.error]="form.controls['customerDeposit'].hasError('insufficientDeposit') && 
                                                          (form.controls['customerDeposit'].dirty || form.controls['customerDeposit'].touched)"
                                            *ngIf="_getDepositAmount() > 0">
                                            A minimum deposit of 
                                            <ng-container *ngIf="form.controls['customerDeposit'].hasError('insufficientDeposit') && 
                                                                 (form.controls['customerDeposit'].dirty || form.controls['customerDeposit'].touched)">
                                                {{form.controls['customerDeposit'].errors?.insufficientDeposit?.required | currency:'AUD':'symbol-narrow'}}
                                            </ng-container>
                                            <ng-container *ngIf="!(form.controls['customerDeposit'].hasError('insufficientDeposit') && 
                                                                   (form.controls['customerDeposit'].dirty || form.controls['customerDeposit'].touched))">
                                                {{_getDepositAmount() | currency:'AUD':'symbol-narrow'}}
                                            </ng-container>
                                            is required because the total cost exceeds the 
                                            {{WABSLoanLimit | currency:'AUD':'symbol-narrow':'1.0-0'}} loan limit
                                        </mat-hint>
                                    </div>
                                </div>
                            </div>
                            <div fxFlex>
                                <div fxFlex fxFlex.gt-sm="80%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px"
                                    fxLayoutGap.lt-md="0px">
                                    <div fxFlex fxLayout="column">
                                        <p>Total loan amount</p>
                                    </div>
                                    <div fxFlex fxFlex.gt-sm="50%" fxLayout="column">
                                        <span data-cy="display.financeAmount" 
                                            [class.text-error]="form.controls['financeAmount'].invalid && form.controls['financeAmount'].touched">
                                            {{form.get('financeAmount').value | currency:'AUD':'symbol-narrow'}}
                                        </span>
                                        <mat-error *ngIf="form.controls['financeAmount'].hasError('min') && form.controls['financeAmount'].touched"
                                            class="subscript">
                                            Total amount must be greater than $0
                                        </mat-error>
                                        <mat-error *ngIf="form.controls['financeAmount'].hasError('max') && form.controls['financeAmount'].touched"
                                            class="subscript">
                                            Total amount cannot exceed {{WABSLoanLimit | currency:'AUD':'symbol-narrow':'1.0-0'}}.
                                            Please increase the deposit amount.
                                        </mat-error>
                                    </div>
                                </div>
                            </div>
                            <div fxFlex>
                                <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign.gt-sm="start center"
                                    fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                                    <div fxFlex>
                                        I confirm my customer's household income is less than $210,000
                                    </div>
                                    <div fxFlex fxFlex.gt-sm="50%">
                                        <mat-button-toggle-group fxFlex fxFlex.gt-sm="120px" formControlName="isTotalIncomeLessThanThreshold">
                                            <mat-button-toggle fxFlex [value]="true">Yes</mat-button-toggle>
                                            <mat-button-toggle fxFlex [value]="false">No</mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </mat-card-content>
                </mat-card>
            </section>
        </ng-container>

        <section *ngIf="formMode !== QuoteFormCrudMode.Create && quoteStatus !== 'Cancelled'">
            <h3>Verification</h3>
            <mat-card>
                <mat-card-content fxLayout="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                    <div fxFlex>
                        <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                            <quote-documents [quoteExternalId]="quoteId" [quoteStatus]="quoteStatus" [quoteFormModel]="model"
                                (onDocumentAvailabilityUpdated)="_onDocumentAvailabilityChange($event)">
                            </quote-documents>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </section>

        <section *ngIf="_shouldDisplayBottomActions()">
            <ng-container *ngTemplateOutlet="tmplActions"></ng-container>
        </section>
    </form>
</section>
<bp-loading-overlay [isLoading]="loading"></bp-loading-overlay>

<ng-template #tmplViewMode [formGroup]="form">
    <section>
        <h3>Customer details</h3>
        <mat-card>
            <mat-card-content fxLayout="column" fxLayoutGap="20px" fxLayoutGap.lt-md="10px">
                <div fxFlex>
                    <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex>Customer first name</div>
                        <div fxFlex>{{ form.get('firstName').value }}</div>
                    </div>
                </div>
                <div fxFlex>
                    <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex>Customer last name</div>
                        <div fxFlex>{{ form.get('lastName').value }}</div>
                    </div>
                </div>
                <div fxFlex>
                    <div fxFlex fxFlex.gt-sm="80%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex>Customer NMI</div>
                        <div fxFlex>{{ form.get('nmi').value }}</div>
                    </div>
                </div>
                <div fxFlex>
                    <div fxFlex fxFlex.gt-sm="80%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex>Installation address</div>
                        <div fxFlex>{{ form.get('installationAddress').value | fullAddress }}</div>
                    </div>
                </div>
                <div fxFlex>
                    <div fxFlex fxFlex.gt-sm="80%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex>Customer email</div>
                        <div fxFlex>{{ form.get('email').value }}</div>
                    </div>
                </div>
                <div fxFlex>
                    <div fxFlex fxFlex.gt-sm="80%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex>Customer phone number</div>
                        <div fxFlex>{{ form.get('mobile').value }}</div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </section>

    <section>
        <h3>Rebate details</h3>
        <mat-card>
            <mat-card-content fxLayout="column" fxLayoutGap="20px" fxLayoutGap.lt-md="10px">
                <div fxFlex>
                    <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex>Cost of installation</div>
                        <div fxFlex>{{ form.get('installationPrice').value | currency:'AUD':'symbol-narrow' }}</div>
                    </div>
                </div>
                <div fxFlex>
                    <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex>Cost of battery system</div>
                        <div fxFlex>{{ form.get('packagePrice').value | currency:'AUD':'symbol-narrow' }}</div>
                    </div>
                </div>
                <div fxFlex>
                    <div fxFlex fxFlex.gt-sm="80%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex>Total cost of system (GST inclusive)</div>
                        <div fxFlex>{{ _getTotalSystemAndInstallationCost() | currency:'AUD':'symbol-narrow' }}</div>
                    </div>
                </div>
                <div fxFlex>
                    <div fxFlex fxFlex.gt-sm="80%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex>Total cost of system (GST exclusive)</div>
                        <div fxFlex>{{ _getTotalSystemAndInstallationCostGstExclusive() | currency:'AUD':'symbol-narrow' }}</div>
                    </div>
                </div>
                <div fxFlex>
                    <div fxFlex fxFlex.gt-sm="80%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex>Applicable rebate amount</div>
                        <div fxFlex>{{ form.get('activities.0.rebateAmount').value | currency:'AUD':'symbol-narrow' }}</div>
                    </div>
                </div>
                <div fxFlex>
                    <div fxFlex fxFlex.gt-sm="80%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex>Total amount owed by the customer</div>
                        <div fxFlex>{{ form.get('balance').value | currency:'AUD':'symbol-narrow' }}</div>
                    </div>
                </div>
                <div fxFlex>
                    <div fxFlex fxFlex.gt-sm="80%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex>Chosen VPP</div>
                        <div fxFlex>{{ ENERGY_RETAILER_LABELS[form.get('activities.0.vpp').value] }}</div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </section>

    <section>
      <h3>System details</h3>
      <mat-card>
          <mat-card-content fxLayout="column" fxLayoutGap="20px" fxLayoutGap.lt-md="10px">
              <!-- Battery Details -->
              <div fxFlex>
                  <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                      <div fxFlex>Battery system being installed</div>
                      <div fxFlex *ngIf="_selectedPackages.battery">
                          {{ _selectedPackages.battery.brand }} - {{ _selectedPackages.battery.model }}
                      </div>
                  </div>
              </div>
              <div fxFlex>
                  <div fxFlex *ngIf="multipleBatteryEnabled" fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                      <div fxFlex>Number of batteries</div>
                      <div fxFlex>
                          {{ form.get('numberOfBatteries').value }}
                      </div>
                  </div>
              </div>
              <div fxFlex>
                  <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                      <div fxFlex>Capacity of battery system</div>
                      <div fxFlex *ngIf="_selectedPackages.battery?.energyCapacity">
                          {{ _selectedPackages.battery.energyCapacity }} kWh
                      </div>
                  </div>
              </div>

              <!-- Inverter Details -->
              <div fxFlex>
                  <div fxFlex fxFlex.gt-sm="80%;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                      <div fxFlex>Inverter system</div>
                      <div fxFlex *ngIf="_selectedPackages.inverter">
                          {{ _selectedPackages.inverter.brand }} - {{ _selectedPackages.inverter.model }}
                      </div>
                  </div>
              </div>
          </mat-card-content>
      </mat-card>
    </section>

    <section *ngIf="model.optInFinance">
        <h3>Finance</h3>
        <mat-card>
            <mat-card-content fxLayout="column" fxLayoutGap="20px" fxLayoutGap.lt-md="10px">
                <div fxFlex>
                    <div fxFlex fxFlex.gt-sm="80%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex>Proposed finance amount</div>
                        <div fxFlex>{{ form.get('financeAmount').value | currency:'AUD':'symbol-narrow' }}</div>
                    </div>
                </div>
                <div fxFlex>
                    <div fxFlex fxFlex.gt-sm="80%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
                        <div fxFlex>Deposit (if applicable)</div>
                        <div fxFlex>{{ form.get('customerDeposit').value | currency:'AUD':'symbol-narrow' }}</div>
                    </div>
                </div>

                <div *ngIf="!applicationId" class="info-message">
                    <mat-icon>info_outline</mat-icon>
                    <span>Application management is not currently available for this quote.</span>
                </div>
            </mat-card-content>

            <mat-divider *ngIf="_canResendFinanceLink() || applicationId"></mat-divider>

            <mat-card-actions *ngIf="_canResendFinanceLink() || applicationId">
                <a *ngIf="applicationId"
                  mat-stroked-button
                  color="primary"
                  [routerLink]="['/application/detail', applicationId]"
                  data-cy="button.viewFinanceApplication">
                    <mat-icon>launch</mat-icon>
                    <span>View Application</span>
                </a>
                <button *ngIf="_canResendFinanceLink()"
                        mat-raised-button
                        color="primary"
                        (click)="resendFinanceLink()"
                        data-cy="button.resendFinanceLink">
                    <mat-icon>send</mat-icon>
                    <span>Send New Link</span>
                </button>
            </mat-card-actions>
        </mat-card>
    </section>
</ng-template>

<ng-template #tmplActions>
    <mat-card fxLayout="column">
        <mat-card-content fxLayout="column" fxLayoutGap="20px" fxLayoutGap.lt-md="10px">
            <div fxFlex>
                <div fxFlex fxFlex.gt-sm="80%;" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="15px">
                    <div fxFlex fxLayout="row" fxLayoutGap="15px" fxLayoutGap.lt-md="5px">
                        <button *ngIf="formMode !== QuoteFormCrudMode.View;else btnStartEdit" type="submit" mat-raised-button
                            color="primary" data-cy="button.submit">
                            {{ formMode === QuoteFormCrudMode.Edit ? 'Update' : 'Submit' }}
                        </button>
                        <ng-template #btnStartEdit>
                            <button type="button" mat-raised-button color="primary" (click)="startEditing()" [disabled]="!_canEdit()"
                                data-cy="button.editQuoteRecord">
                                Edit Quote Record
                            </button>
                        </ng-template>

                        <button *ngIf="formMode === QuoteFormCrudMode.Edit" type="button" mat-raised-button color="warn"
                            (click)="cancelEditing()">
                            Cancel
                        </button>

                        <button *ngIf="formMode === QuoteFormCrudMode.View" [disabled]="!_canCancel()" type="button" mat-raised-button
                            color="warn" (click)="cancelQuote()">
                            Withdraw Quote Record
                        </button>

                         <button *ngIf="formMode === QuoteFormCrudMode.View && showResendRebateButton()" 
                            type="button"
                            mat-raised-button
                            color="primary"
                            (click)="resendRebateQuote()"
                        >
                            <mat-icon>email</mat-icon>
                            <span> Re-send rebate email </span>
                        </button>
                    </div>
                    <div *ngIf="formMode === QuoteFormCrudMode.View && !form.get('optInFinance').value" fxFlex fxLayout="row"
                        fxLayoutGap="15px" fxLayoutGap.lt-md="5px">
                        <button type="button" mat-raised-button color="primary" [disabled]="!_canApplyForFinance()"
                            (click)="applyForFinance()">Apply for Finance</button>
                    </div>
                    <div *ngIf="formMode === QuoteFormCrudMode.View" fxFlex fxLayout="row" fxLayoutGap="15px" fxLayoutGap.lt-md="5px">
                        <button [disabled]="!_canConfirmInstallation()" type="button" mat-raised-button color="primary"
                            (click)="confirmInstallation()">
                            Confirm Installation Completion
                        </button>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</ng-template>
